import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ApplicationState } from "../../../store";
import * as httpClient from "../../../util/httpClient";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";

const GenericResponseLandingPage = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const partnerDisplayName: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ''
    );
    const partnerEmail: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.email
            ? state.configurationState.configuration.partnerConfig.email
            : ''
    );

    const query = new URLSearchParams(props.location.search);
    let code: any = query.get("Accesscode");
    code = code?.includes(" ") ? code.replace(/\s/g, "+") : code;

    const retailerCode: any = query.get("retailer") || query.get("RETAILER");

    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            offercode: code ? code : "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [showMaxAttemptErrorMsg, setShowMaxAttemptErrorMsg] = useState(false);
    const [backgroundImage, setBackgroundImage] = useState("https://cdn.ezshield.net/images/_Shared/_Logos/CS_Insurance_GSC_BG.jpg");
    const [partnerName, setPartnerName] = useState("")

    const [state, setState] = useState({
        offercode: "",
        showErrorMessage: false,
        errorMsg: "offercode Code is Required",
        isLoading: false,
    });

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language").length > 0
                        ? !!document.cookie
                            .split(";")
                            .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                            .split("=")[1]
                            ? document.cookie
                                .split(";")
                                .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                                .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);

    useEffect(() => {
        if (partnerID === 2649) {
            setPartnerName("TransUnion");
        } else {
            setPartnerName(partnerDisplayName);
        }
    }, [partnerID]);

    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        setShowAccessCodeField(false);
        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };
    const checkRetailerExists = async (retailerCode: string) => {
        let isRetailerExists = false;
        const requestBody = {
            RetailerCode: retailerCode
        }
        await httpClient
            .sendRequest("POST", `api/PartnerService/getRetailerDetails`, requestBody)
            .then((data) => {
                if (!data["hasError"] && data["retailerCode"] !== null) {
                    if (data["retailerCode"].toLowerCase() === retailerCode.toLowerCase()) {
                        isRetailerExists = true;
                    }
                }
            })
            .catch((error) => {
                isRetailerExists = false;
            });
        return isRetailerExists;
    };

    const onSubmit = (data: any) => {
        setShowAccessCodeField(false);
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            provisionalID: data.offercode,
            partnerID: partnerID,
        };

        httpClient
            .sendRequest("POST", `api/PssLandingPage/GetPssLandingPage3?enrollFileRequired=true`, requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding?.[0]?.statusCode && data.provisionalResponseLanding?.[0]?.statusCode === '5051') {
                    setShowMaxAttemptErrorMsg(true);
                    setState({ ...state, showErrorMessage: false, errorMsg: "offercode Code is Required", isLoading: false, offercode: "" });
                }
                else if (data.provisionalResponseLanding.length === 0 || !data.provisionalResponseLanding?.[0]?.provisionalID) {
                    setShowAccessCodeField(true);
                    setState({ ...state, showErrorMessage: false, errorMsg: "offercode Code is Required", isLoading: false, offercode: "" });
                } else {
                    if (data.provisionalResponseLanding[0].provisionalID.trim() === requestBody.provisionalID.trim()) {
                        if (retailerCode != null && retailerCode !== "") {
                            props.history.push({
                                pathname:
                                    "/Register?Type=" +
                                    data.provisionalResponseLanding[0].contractStatus +
                                    "&VALUE=" +
                                    data.provisionalResponseLanding[0].provisionalID +
                                    "&RETAILERCODE=" +
                                    retailerCode +
                                    "&GNDNRLL=PSS",
                            });
                        } else {
                            props.history.push({
                                pathname:
                                    "/Register?Type=" +
                                    data.provisionalResponseLanding[0].contractStatus +
                                    "&VALUE=" +
                                    data.provisionalResponseLanding[0].provisionalID +
                                    "&GNDNRLL=PSS",
                            });
                        }
                        window.location.reload();
                       
                    } else {
                        if (retailerCode != null && retailerCode !== "") {
                            props.history.push({
                                pathname:
                                    "/Register?Type=" +
                                    data.provisionalResponseLanding[0].contractStatus +
                                    "&VALUE=" +
                                    data.provisionalResponseLanding[0].provisionalID +
                                    "&RETAILERCODE=" +
                                    retailerCode +
                                    "&GNDNRLL=GBPSS",
                            });
                            window.location.reload();
                        } else {
                            const requestBodyAccessCode = {
                                accessCode: state.offercode
                            };
                            httpClient
                                .sendRequest("POST", `api/PartnerService/GetRetailerCodeByAccessCode`, requestBodyAccessCode)
                                .then(async (retailerdata) => {
                                    if (!retailerdata["HasError"] && retailerdata["cgW_RetailerCode"] !== null) {
                                        const isRetailerExists = checkRetailerExists(retailerdata["cgW_RetailerCode"]);
                                        if (await isRetailerExists) {
                                            props.history.push({
                                                pathname:
                                                    "/Register?Type=" +
                                                    data.provisionalResponseLanding[0].contractStatus +
                                                    "&VALUE=" +
                                                    data.provisionalResponseLanding[0].provisionalID +
                                                    "&GNDNRLL=GBPSS" +
                                                    "&RETAILERCODE=" +
                                                    retailerdata["cgW_RetailerCode"],

                                            });
                                        } else {
                                            props.history.push({
                                                pathname:
                                                    "/Register?Type=" +
                                                    data.provisionalResponseLanding[0].contractStatus +
                                                    "&VALUE=" +
                                                    data.provisionalResponseLanding[0].provisionalID +
                                                    "&GNDNRLL=GBPSS",
                                            });
                                        }
                                    } else {
                                        props.history.push({
                                            pathname:
                                                "/Register?Type=" +
                                                data.provisionalResponseLanding[0].contractStatus +
                                                "&VALUE=" +
                                                data.provisionalResponseLanding[0].provisionalID +
                                                "&GNDNRLL=GBPSS",
                                        });
                                    }                                  
                                    window.location.reload();
                                })
                                 .catch(function (error) {
                                     setValue("offercode", null);
                                     reset();
                                     trigger();
                                     setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, offercode: "" });
                                 });
                        }                        
                    }                  
                   
                }
            })
            .catch(function (error) {
                setValue("offercode", null);
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, offercode: "" });
            });
    };

    const handleClick = () => {
        handleSubmit(onSubmit);
        window.addToDataLayer({ event: "GSC Activate My Account"});
    }

    return (
        <React.Fragment>
            <div>            
                {showAccessCodeField ? (
                    <PSSBannerMessage layout={"gsclanding"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
                ) : errors.offercode ? (
                    <PSSBannerMessage layout={"gsclandingerrormsg"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
                    ) : showMaxAttemptErrorMsg ? (<PSSBannerMessage layout={"gscmaxattempterrormsg"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />)
                    : <></>}
                <div className="gsc-container">
                    <div className="gsc-container-card">
                        <div className="gsc-container-card-left">
                            <div
                                className="partner"
                                style={{
                                    backgroundImage: `url(${backgroundImage})`,
                                }}
                            >
                                 <h2>Welcome to {partnerName} Identity Protection</h2>
                            </div>
                            <div className="gsc-partner-message">
                                <p>
                                    At {partnerName}, we believe that protecting the identities of our members is a serious responsibility.
                                    Safeguarding sensitive personal and financial information is at the heart of what our team focuses on every day and
                                    we take tremendous pride in our identity protection solutions. 
                                </p>
                            </div>
                        </div>
                        <div className="gsc-container-card-right">
                            <h2>
                                <span>Activate Your </span> <span>Identity Protection</span>
                            </h2>
                            <div className="get-started-text">
                                <span className="let-get-started"><b>LET'S GET STARTED</b> <i>Enter your code to access your account</i></span>
                            </div>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div>
                                    <label className='hide-label' htmlFor="offercode">Enter Code</label>
                                </div>
                                <div className="code-input">
                                    <input
                                        type="text"
                                        placeholder="ENTER CODE"
                                        id="offercode"
                                        name="offercode"
                                        onChange={handleInputChange}
                                        ref={register({
                                            required: true,
                                            maxLength: 100,
                                        })}
                                    />
                                    {errors.offercode && errors.offercode.type === "required" && !state.showErrorMessage && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">Please enter a valid code to continue</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div >
                                    <input
                                        type="submit"
                                        onClick={() => handleClick()}
                                        className="enrollment-steps-button"
                                        value="ACTIVATE MY ACCOUNT"
                                    />
                                </div>
                            </form>
                            <div className="login-link">
                                <a href='/app/Login' onClick={() => {
                                    window.addToDataLayer({ event: "GSC Login to my account" });
                                }}>I've already enrolled, Login to my account<span aria-hidden="true">{'>'}</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="question-link ">
                        <span> QUESTION? If you need help, email us at <a href={`mailto:${partnerEmail}` }>{partnerEmail}</a></span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default GenericResponseLandingPage;
